<template>
  <div class="section-gallery-page">
    <PageHeader
      :title="blockData.page_title"
      :subtitle="blockData.subtitle"
    />

    <div class="section-gallery-page__inner">
      <div class="section-gallery-page__panel">
        <p v-if="!items.length" class="section-gallery-page__empty">
          No gallery images in this section yet.
        </p>

        <div v-else class="section-gallery-grid">
        <button
          v-for="(item, index) in items"
          :key="item.id"
          type="button"
          class="section-gallery-grid__item"
          @click="openGallery(index)"
        >
          <img
            :src="item.image_url"
            :alt="item.caption || item.title || `Gallery image ${index + 1}`"
            loading="lazy"
          />
          <span v-if="item.caption" class="section-gallery-grid__caption">
            {{ item.caption }}
          </span>
        </button>
        </div>
      </div>
    </div>

    <ImageGalleryModal
      :is-open="modalOpen"
      :images="imageUrls"
      :captions="captions"
      :start-index="modalStartIndex"
      :product-name="blockData.section_name || blockData.page_title"
      @close="modalOpen = false"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import PageHeader from '../components/PageHeader.vue';
import ImageGalleryModal from '../components/ImageGalleryModal.vue';

export default defineComponent({
  name: 'SectionGallery',
  components: {
    PageHeader,
    ImageGalleryModal
  },
  props: {
    blockData: {
      type: Object,
      required: true,
      default: () => ({
        page_title: '',
        subtitle: '',
        section: '',
        section_name: '',
        items: []
      })
    }
  },
  data() {
    return {
      modalOpen: false,
      modalStartIndex: 0
    };
  },
  computed: {
    items() {
      return this.blockData.items || [];
    },
    imageUrls() {
      return this.items.map((item) => item.image_url).filter(Boolean);
    },
    captions() {
      return this.items.map((item) => item.caption || '');
    }
  },
  methods: {
    openGallery(index) {
      this.modalStartIndex = index;
      this.modalOpen = true;
    }
  }
});
</script>
